import t, { AsHtml } from "utils/translate";
import Column from "components/Column";
import SiteWrapper from "components/SiteWrapper";
import StickyFooter from "components/StickyFooter";

import styles from "./styles.module.scss";
import useAppContext from "components/AppContext";

const ClinicalIneligible = (): JSX.Element => {
  const { profile } = useAppContext();
  const { isIAP, isRegistered } = profile || {};
  const isActive = isIAP === false && isRegistered === false;
  const onContinue = () => {
    window.location.href = t("CLINICAL_INELIGIBLE_LINK");
  };

  const ineligibleHeader = isActive ? t("SEQUENCE_INELIGIBLE_HEADER", { firstName: profile?.firstName }) : t("CLINICAL_INELIGIBLE_HEADER");
  const ineligibleText = isActive ? `${t("SEQUENCE_INELIGIBLE_BODY1")} ${t("SEQUENCE_INELIGIBLE_BODY2")}` : t("CLINICAL_INELIGIBLE_TEXT");

  return (
    <SiteWrapper size="small">
      <Column className={styles.content}>
        <div className={styles.logo}></div>
        <h1 className={styles.heading}>{ineligibleHeader}</h1>
        <div className={styles.text}>
          <AsHtml value={ineligibleText} tagType="div" />
        </div>
        {!isActive && <StickyFooter
          message={{
            label: t("CLINICAL_INELIGIBLE_DISCLAIMER"),
            className: styles.disclaimer
          }}
          nextButtonProps={{ onNext: onContinue, label: t("LEARN_MORE") }}
        />}
      </Column>
    </SiteWrapper>
  );
};

export default ClinicalIneligible;
